import isCancelError from './isCancelError';

export default function absorbCancellation<E extends Error>(err: E) {
  if (!isCancelError(err)) {
    throw err;
  }
}
